import React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";
import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = `${process.env.REACT_APP_TRACKING_ID}`;
ReactGA.initialize(GA_MEASUREMENT_ID);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);


